import React, { useContext } from "react";
import "../css/newsProducts.css";
import { useNavigate } from "react-router-dom";
import { Store } from "../../../../Store";
import { formatCurrency } from "../../../../format/formatDate";

const NewsProducts = ({ data }) => {
  const navigate = useNavigate();

  const { dispatch: ctxDispatch } = useContext(Store);
  const saveBreadcrumb = (title, slug, url) => {
    const breadcrumb = [
      {
        title: "Bài viết",
        slug: "/bai-viet",
      },
      {
        title,
        slug,
      },
    ];
    ctxDispatch({
      type: "SET_BREADCRUMB",
      payload: breadcrumb,
    });
    localStorage.setItem("resentBread", JSON.stringify(breadcrumb));
    navigate(url);
  };

  console.log("data>", data);

  return (
    <section className="media-talking-about-us">
      <div className="container">
        <h2 className="text-center default-box-title">SẢN PHẨM</h2>
        <div>
          <h3 className="default-box-title">Sản phẩm mới nhất</h3>
          <div className="bg-layer my-md-5 my-4 px-xl-4 px-3">
            <div className="box-wrap">
              <div className="items">
                {data?.map((item, index) => (
                  <div key={index} className="item-wrap bg-white shadow-sm p-3">
                    <div className="text-center mb-3">
                      <div
                        className="a"
                        style={{
                          display: "block",
                          width: "100%",
                          overflow: "hidden",
                          cursor: " pointer",
                        }}
                        onClick={() =>
                          saveBreadcrumb(
                            item.title,
                            item.slug,
                            `/san-pham/${item.category?.slug}/${item.slug}`
                          )
                        }
                      >
                        <img
                          data-src={item.thumbnail}
                          className=" thumbnail owl-lazy zoom-image"
                          alt={item.name}
                          loading="lazy"
                          src={item?.imagesUrl?.[0]}
                          style={{
                            width: "100%",
                            aspectRatio: "3/2",
                            objectFit: "cover",
                            opacity: "1",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </div>
                    </div>
                    <div className="row ">
                      <h3 className="mb-3">
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            saveBreadcrumb(
                              item.title,
                              item.slug,
                              `/san-pham/${item.category?.slug}/${item.slug}`
                            )
                          }
                        >
                          {item.name}
                        </div>
                      </h3>
                      {item?.salePrice && Number(item?.salePrice) > 0 ? (
                        <p className="product-price">
                          {item.originalPrice ? (
                            <span className="origin-price me-2">
                              {formatCurrency(item.originalPrice)} đ
                            </span>
                          ) : null}
                          {formatCurrency(item.salePrice)} đ
                        </p>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-center more">
                <div
                  onClick={() =>
                    saveBreadcrumb("Sản phẩm mới nhất", "san-pham", `/san-pham`)
                  }
                  className="btn"
                >
                  <img
                    src="/images/icons/list-icon-white.png"
                    className="mw-100 me-2"
                    alt=""
                    loading="lazy"
                  />
                  Xem tất cả
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsProducts;
